import { cannotBeEmptySet, cannotBeEmptyString, mustBeValidEmail, unknown, valid } from "../../../../Shared/validationUtils";
export const validateField = (field)=>(value)=>{
        const fieldValidators = validator[field];
        let result = unknown;
        for(let i = 0; i < fieldValidators.length; i++){
            result = fieldValidators[i](value);
            if (result.status != 'unknown') break;
        }
        return result.status == "unknown" ? valid : result;
    };
const validator = {
    firstName: [],
    lastName: [
        cannotBeEmptyString("Achternaam mag niet ontbreken")
    ],
    emailAddress: [
        cannotBeEmptyString("E-mailadres mag niet ontbreken"),
        mustBeValidEmail("E-mailadres lijkt niet geldig")
    ],
    gender: [],
    newsletters: [
        cannotBeEmptySet("Kies minstens één nieuwsbrief")
    ]
};
